import { isEmpty } from "lodash";

export const getPortTagsRequestParams = ({ auth, method = "read" }) => {
  const isStandaloneMode = !auth.orgs || Object.keys(auth.orgs).length === 0;
  const apiBaseUrl = isStandaloneMode ? `/orgs/:orgId` : `/ents/:entId/orgs/:orgId`;
  const apiPaths = `${apiBaseUrl}/sites/:siteId/settings/tags/portTags.${method}`;

  const restfulParamsConfig = {
    standalone: {
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
    nonStandalone: {
      entId: auth.realm?.id,
      orgId: auth.orgs?.id,
      siteId: auth.sites?.id,
    },
  };

  const restfulParams = isStandaloneMode ? restfulParamsConfig["standalone"] : restfulParamsConfig["nonStandalone"];

  return {
    apiPaths,
    restfulParams
  };
}

export const getPortTagsCreatePayload = ({ tags }) => {
  return {
    data: {
      tagName: tags?.tagName ? tags.tagName : null
    }
  }
}

export const getWiredPortTagsRequestParams = ({ auth, method = "read" }) => {
  const isStandaloneMode = !auth.orgs || Object.keys(auth.orgs).length === 0;
  const apiBaseUrl = isStandaloneMode ? `/orgs/:orgId` : `/ents/:entId/orgs/:orgId`;
  const apiPaths = `${apiBaseUrl}/sites/:siteId/settings/ports.${method}`;

  const restfulParamsConfig = {
    standalone: {
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
    nonStandalone: {
      entId: auth.realm?.id,
      orgId: auth.orgs?.id,
      siteId: auth.sites?.id,
    },
  };

  const restfulParams = isStandaloneMode ? restfulParamsConfig["standalone"] : restfulParamsConfig["nonStandalone"];

  return {
    apiPaths,
    restfulParams
  }
};

export const getWiredPortTagsUpdatePayload = ({ activeRow, chipIds }) => {
  const payload = {
    updates: [
      {
        deviceId: activeRow.macAddress,
        "wired.port": [
          {
            id: activeRow.id,
            portIndex: activeRow.portIndex,
            deviceCategory: activeRow.deviceCategory,
            portTags: chipIds,
            portProfile: activeRow.portProfile,
            portState: activeRow.portState,
            portType: activeRow.portType,
            PVID: activeRow.PVID,
            allowVlan: activeRow.allowVlan,
            poeState: activeRow.poeState,
            operation: {
              type: activeRow.operation?.type,
              mirrorPort: activeRow.operation?.mirrorPort ?? [],
              mirrorMode: activeRow.operation?.mirrorMode ?? "",
              aggregatePort: activeRow.operation?.aggregatePort ?? [],
              aggregateType: activeRow.operation?.aggregateType ?? "",
            },
            speed: activeRow.speed,
            ddpState: activeRow.ddpState,
            lbdState: activeRow.lbdState,
            portName: activeRow.portName
          },
        ],
      },
    ],
  };

  return {
    payload
  }
}

export const getWiredPortTagsRemovePayload = ({ activeRow, chipIds }) => {
  const payload = {
    updates: [
      {
        deviceId: activeRow.macAddress,
        "wired.port": [
          {
            id: activeRow.id,
            portIndex: activeRow.portIndex,
            deviceCategory: activeRow.deviceCategory,
            portTags: chipIds,
            portProfile: activeRow.portProfile,
            portState: activeRow.portState,
            portType: activeRow.portType,
            PVID: activeRow.PVID,
            allowVlan: activeRow.allowVlan,
            poeState: activeRow.poeState,
            operation: {
              type: activeRow.operation?.type,
              mirrorPort: activeRow.operation?.mirrorPort ?? [],
              mirrorMode: activeRow.operation?.mirrorMode ?? "",
              aggregatePort: activeRow.operation?.aggregatePort ?? [],
              aggregateType: activeRow.operation?.aggregateType ?? "",
            },
            speed: activeRow.speed,
            ddpState: activeRow.ddpState,
            lbdState: activeRow.lbdState,
            portName: activeRow.portName
          },
        ],
      },
    ],
  };

  return {
    payload
  }
}

export const initChips = ({ chips, tags }) => {
  // 1. Use chip id to change the format to { tagName: xxx, tagId: xxx }.
  // 2. Remove saved chips which no longer exist in tags.
  const comparisonEnum = tags.reduce((acc, tag) => {
    return {
      ...acc,
      [tag.tagId]: tag
    }
  }, {});

  const newChips = chips.map(chipId => {
    const matchedChip = comparisonEnum[chipId];
    return isEmpty(matchedChip) ? null : matchedChip;
  }).filter(chip => !!chip)

  return newChips
}